import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PHOTO_REVIEW_UISTATE } from '../model/photo-review.constant';

@Component({
	selector: 'cv-photo-content-detail',
	templateUrl: './photo-content-detail.component.html',
	styleUrls: ['./photo-content-detail.component.scss']
})
export class PhotoContentDetailComponent implements OnInit {
	contentType = PHOTO_REVIEW_UISTATE.TAB_TITLES;
	galleryOptions: any;
	@Input() info: any;
	@Input() type: string;

	ngOnInit(): void {
		this.galleryOptions = [
			{
				width: '100%',
				height: '200px',
				thumbnails: false,
				lazyLoading: true,
				arrowPrevIcon: 'fas fa-chevron-left',
				arrowNextIcon: 'fas fa-chevron-right',
				imageDescription: true,
				previewKeyboardNavigation: true
			}
		];
	}
}
